import { render, staticRenderFns } from "./LinkFooter.vue?vue&type=template&id=33a8b28d&scoped=true"
import script from "./LinkFooter.vue?vue&type=script&lang=js"
export * from "./LinkFooter.vue?vue&type=script&lang=js"
import style0 from "./LinkFooter.vue?vue&type=style&index=0&id=33a8b28d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a8b28d",
  null
  
)

export default component.exports